import { getController } from '@/services/service'

const url = 'report_sub_types'

export const reportSubTypeService = {
	...getController<Api.ReportSubType, Api.ReportSubTypePostInput>(url),
}

export default reportSubTypeService
